/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PermissionSchemePageType from '@jira/permissions-administration__pages-permission-scheme/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyPermissionSchemePage: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof PermissionSchemePageType>(() =>
	markAsProductBundleReady(
		// eslint-disable-next-line jira/import/file-extension-required
		import(
			/* webpackChunkName: "async-jira-permission-scheme", jiraSpaEntry: "async-jira-permission-scheme" */ '@jira/permissions-administration__pages-permission-scheme'
		),
	),
);

const AsyncPermissionSchemePage = (): React.JSX.Element => (
	<LazyPage Page={LazyPermissionSchemePage} pageId="jira-permission-scheme" shouldShowSpinner />
);

export default AsyncPermissionSchemePage;
